import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useState,useEffect } from 'react';
import axios from 'axios';
import NotarialBookDetails from './crud_transaction/transaction_details';
import BackdropModal from '../../components/modals/backdrop_modal';
import apiRequest from '../../services/apiService';
import '../../styles/ReusableDataTable.css';


import TransactionsTable from './crud_transaction/transactions_table';

const pk = "transaction_id";

const columns = [
    { id: 'id',                         field: 'transaction_id',                  headerName: 'DOCUMENT#' },
    { id: 'document_name',              field: 'document_name',                   headerName: 'NATURE OF INS' },
    // { id: 'transaction_status',         field: 'transaction_status',              headerName: 'Status'},

    { id: 'date_created',         field: 'date_created',          headerName: 'Date Time'},
    { id: 'attachment_id_type',   field: 'attachment_id_type',    headerName: 'ID'},
    { id: 'attachment_id_number', field: 'attachment_id_number',  headerName: 'ID#'},



    { id: 'first_party_full_name',      field: 'first_party_full_name',           headerName: '1ST PARTY' },
    { id: 'second_party_full_name',     field: 'second_party_full_name',          headerName: '2ND PARTY' },


    { id: 'document_price',             field: 'document_price',                 headerName: 'FEE' },
    // { id: 'transaction_payment_status', field: 'transaction_payment_status',      headerName: 'PAYMENT' },
    // { id: 'date_released ',             field: 'date_released',                   headerName: 'RELEASED@' },
];


// List of fields that are date fields
const columns_date = ['date_released'];

// List of fields that has status
const columns_status = ['transaction_status','transaction_payment_status'];

// List of fields that will Uppercase
const columns_uppercase = ['document_name','first_party_full_name','second_party_full_name'];


const actions = [
    { label: 'Edit', link: './update', icon: 'bx bx-edit-alt me-1' },
];

const other_actions = [
    // { label: 'View', link: '/delete', icon: 'bx bx-detail me-1' },
];



const CACHE_KEY = 'notarialbook_cache_map_transaction';
const CACHE_TTL = 5 * 60 * 1000; // 5 minutes

const generateCacheKey = (params) => {
  return JSON.stringify(params); // You could also hash this if needed
};



const fetchData = async ({ page, rowsPerPage, sortBy, sortOrder, searchTerm, ...filters }) => {


    const queryParams = new URLSearchParams(window.location.search);
  
    const params = {
        page     : parseInt(queryParams.get('page')) ? parseInt(queryParams.get('page')) : 1,
        page_size: rowsPerPage,
        ordering : sortBy ? `${sortOrder === 'desc' ? '-' : ''}${sortBy}`: undefined,
        search   : queryParams.get('searchTerm') ?? (searchTerm || undefined),
        type:"NOTARIAL BOOK",
        ...filters,
    };

    return await apiRequest('GET', '/notarialbook/', null, params);
};


/*
const fetchData = async ({ page, rowsPerPage, sortBy, sortOrder, searchTerm, filters }) => {
  const params = {
    page,
    page_size: rowsPerPage,
    ordering: sortBy ? `${sortOrder === 'desc' ? '-' : ''}${sortBy}` : undefined,
    search: searchTerm || undefined,
    type:"NOTARIAL BOOK",
    ...filters,
  };

  const cacheKey = generateCacheKey(params);
  const rawCache = localStorage.getItem(CACHE_KEY);
  const cacheMap = rawCache ? JSON.parse(rawCache) : {};

  // Clean expired entries
  const now = Date.now();
  for (const key in cacheMap) {
    if (now - cacheMap[key].timestamp > CACHE_TTL) {
      delete cacheMap[key];
    }
  }

  // Return from cache if available
  if (cacheMap[cacheKey]) {
    console.log('Using cached data for:', cacheKey);
    return cacheMap[cacheKey].data;
  }

  // Fetch and cache
  const response = await apiRequest('GET', '/notarialbook/', null, params);
  cacheMap[cacheKey] = {
    timestamp: now,
    data: response,
  };

  //localStorage.setItem(CACHE_KEY, JSON.stringify(cacheMap));
  return response;
};*/



const TransactionNotarialBookTable = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(location.search);


     // FILTERS
    const [filtersState, setFiltersState] = useState({});
    const filters = [
      { field: 'document_name', label: 'Nature of Instrument', value: queryParams.get('document_name') || '', type: 'text',placholder:'Nature of Instrument' },

      // { field: 'date_created', label: 'Date From', value: queryParams.get('date') || '', type: 'date' },

  


      { field: 'transaction_status', label: 'Status', value: queryParams.get('transaction_status') || '', type: 'select', options: [
          { value: '', label: 'All' },
          { value: 'RELEASED', label: 'Released' },
          { value: 'PENDING', label: 'Pending' },
        ]
      },


      { field: 'date_created', label: 'Date Created', value: queryParams.get('date') || '', type: 'date_range' },
      { field: 'gender', label: 'Gender', value: queryParams.get('gender') || '', type: 'select', options: [
          { value: '', label: 'All' },
          { value: 'MALE', label: 'Male' },
          { value: 'FEMALE', label: 'Female' },
        ]
      },
    ];


    const getStatusWithColor = (column, value) => {
        if (columns_status.includes(column)) {
            const statusColors = {
                'RELEASED'  : 'badge bg-success',
                'PENDING'    : 'badge bg-warning',
                'DEACTIVATED': 'badge bg-danger',

                'PAID': 'badge bg-primary ',

            };

         
            const color = statusColors[value.toUpperCase()] || 'white';
            return (
                <span className={color}>
                    {value}
                </span>
            );
        }
        return value; // For other columns, return the value as is
    };

  const deleteEndpoint = `${process.env.REACT_APP_API_URL}/notarialbook`;
  const [selectedItem, setSelectedItem] = useState(null);

  const handleViewDetails = (item) => {
    console.log(item);
    setSelectedItem(item);
    setOpen(true);
  };

  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleSave = () => {
    handleClose();
  };


  const formatDateOnly = (date) => {
  if (!date) return null;
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};


const handleFilterChange = (field, value) => {
  if (field === 'date_created' && Array.isArray(value)) {
    const formattedDates = value.map(date =>
      date ? formatDateOnly(date) : null
    );

    setFiltersState((prevState) => ({
      ...prevState,
      [field]: formattedDates,
    }));
  } else {
    setFiltersState((prevState) => ({
      ...prevState,
      [field]: value,
    }));
  }
};



  return (
    <>
      <TransactionsTable
        fetchDataFn={fetchData}
        columns={columns}
        columns_date={columns_date}
        columns_uppercase={columns_uppercase}
        actions={actions}
        other_actions={other_actions}
        onViewDetails={handleViewDetails}
        deleteEndpoint={deleteEndpoint}
        tableTitle=''
        primarykey={pk}
        onFilterChange={handleFilterChange}
      

        // WITH STATUS COLORING
        cellStylingFn = {getStatusWithColor}

        filters         = {filters}
        filtersState    = {filtersState}
        setFiltersState = {setFiltersState}
        

  
        hasTableHeader = {false}

      />

      <BackdropModal open={open} handleClose={handleClose} handleSave={handleSave} modalTitle="Notary Details" size={"lg"}>
        <NotarialBookDetails selectedItem={selectedItem} />
      </BackdropModal>
    </>
  );
}

export default TransactionNotarialBookTable;